<template>
  <div class="container-login-google" v-if="showButtonLogin">
    <button
      type="submit"
      class="w-full aha-button aha-button-primary aha-button-xl aha-button-login-google"
      @click.prevent="handleGoogleSignin"
    >
      <span
        class="icon"
      >
        <aha-icon
          maintain-color
          name="gg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        />
      </span>
      <slot />
      <aha-spinner class="ml-2 spinner-gg" :class="{'visible': submittingGG}" variant="white" />
    </button>
  </div>
</template>

<script>
import GoogleLoginButtonMixin from '@/mixins/GoogleLoginButtonMixin.vue'

export default {
  name: 'GoogleButtonProfile',
  mixins: [GoogleLoginButtonMixin],
}
</script>

<style lang="scss" scoped>
button.aha-button {
  --tw-shadow: none !important;
  --tw-shadow: none !important;
  --tw-translate-y: 0 !important;

  &:hover {
    @apply bg-primary-100;
  }

  height: 3.5rem;

  .icon {
    position: absolute;
    left: 0.25rem;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.aha-button-login-google{
  &:hover{
    background-color: #257ADC;
    cursor: pointer;
  }
  width: 100%;
  --tw-shadow: none !important;
  --tw-shadow: none !important;
  --tw-translate-y: 0 !important;
  height: 3.5rem;
  -webkit-appearance: button;
  padding-left: 3rem;
  padding-right: 0rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-bg-opacity: 1;
  background-color: #348EF6 ;
  --tw-shadow: 0 4px 0px #257ADC;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  -webkit-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  min-width: 2.5rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(245, 245, 245, var(--tw-text-opacity));
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 100ms;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border-width: 0;
}

.spinner-gg {
  visibility: hidden;

  &.visible {
    visibility: visible;
  }
}
</style>
